import { Button, Card, Col, Divider, Row, Space, Tag } from "antd";
import { BsArrowRight } from "react-icons/bs";
import "./serviceCardView.scss";

import { motion } from "framer-motion";
import impact from "../../assets/images/home/services/impact.webp";
import client from "../../assets/images/home/services/client.webp";
import outcome from "../../assets/images/home/services/outcome.webp";
import challenge from "../../assets/images/home/services/challenge.webp";
import solution from "../../assets/images/home/services/solution.webp";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const MotionCol = motion(Col);

const ServiceCardView = ({ list, buttunData }: any) => {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (hash) {
      // Wait for DOM to be ready (optional delay if needed)
      setTimeout(() => {
        const section: any = document.querySelector(`${hash}`);
        const rect = section.getBoundingClientRect();
        const offset =
          window.pageYOffset + rect.top - window.innerHeight * 0.22;

        window.scrollTo({
          top: offset,
          behavior: "smooth",
        });
      }, 0);
    }
  }, [location]);

  return (
    <>
      <div className="mainDivView">
        <Row gutter={[32, 32]} justify={"center"}>
          {list.map((singleData: any, index: number) => {
            return (
              <MotionCol
                initial={{ opacity: 0, y: 80 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 1 }}
                viewport={{ once: false, amount: 0.2 }} // only animate once when 30% in view
                xs={24} // full width on extra small screens
                sm={12} // half width on small screens
                md={8} // one-third width on medium screens and up
                key={"card" + index}
              >
                {/* <Card title={singleData?.title} className="cardView">
                  <p>{singleData?.desc}</p>
                  <a
                    onClick={() => {
                      const section: any = document.querySelector(
                        `#${singleData?.id}`
                      );
                      const rect = section.getBoundingClientRect();
                      const offset =
                        window.pageYOffset +
                        rect.top -
                        window.innerHeight * 0.22;

                      window.scrollTo({
                        top: offset,
                        behavior: "smooth",
                      });
                    }}
                  >
                    Learn More
                  </a>
                </Card> */}

                <Card
                  // title={singleData?.title}
                  className={`cardView`}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                  }}
                  bodyStyle={{
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    padding: 0,
                  }}
                >
                  <div style={{ flexGrow: 1 }} className={`cardView${index}`}>
                    <h5>
                      <strong>{singleData?.title}</strong>
                    </h5>
                    <h6>{singleData?.desc}</h6>
                  </div>
                  <div className="buttonSection">
                    <Row justify={"center"}>
                      <Col span={12}>Learn More</Col>
                      <Col span={12}>
                        <Button
                          className={`button${index}`}
                          onClick={() => {
                            const section: any = document.querySelector(
                              `#${singleData?.id}`
                            );
                            const rect = section.getBoundingClientRect();
                            const offset =
                              window.pageYOffset +
                              rect.top -
                              window.innerHeight * 0.22;

                            window.scrollTo({
                              top: offset,
                              behavior: "smooth",
                            });
                          }}
                        >
                          <BsArrowRight />
                        </Button>
                      </Col>
                    </Row>
                    {/* <Button
                      onClick={() => {
                        const section: any = document.querySelector(
                          `#${singleData?.id}`
                        );
                        const rect = section.getBoundingClientRect();
                        const offset =
                          window.pageYOffset +
                          rect.top -
                          window.innerHeight * 0.22;

                        window.scrollTo({
                          top: offset,
                          behavior: "smooth",
                        });
                      }}
                      className="centerButtonHome"
                    >
                      <Space>
                        Learn More
                      </Space>
                    </Button> */}
                  </div>
                </Card>
              </MotionCol>
            );
          })}
        </Row>
        {buttunData && buttunData?.buttonText && (
          <center>
            <Button
              onClick={() => {
                buttunData.buttonAction();
              }}
              className="centerButton"
            >
              <Space>
                {buttunData?.buttonText}
                <BsArrowRight />
              </Space>
            </Button>
          </center>
        )}

        <h3 className="commonTitleHead" style={{ margin: "8vh 0 8vh 0" }}>
          SERVICE DETAILS
        </h3>

        <Row gutter={[32, 32]} justify={"center"}>
          {list.map((singleData: any, index: number) => {
            return (
              <>
                <MotionCol
                  initial={{ opacity: 0, y: 80 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 1 }}
                  viewport={{ once: false, amount: 0.2 }} // only animate once when 30% in view
                  span={24}
                  key={singleData?.id}
                  id={singleData?.id}
                >
                  <>
                    <Card
                      title={
                        <>
                          <h4 className="detailsTitle">{singleData?.title}</h4>
                          <h5>
                            <b>Overview:</b>
                          </h5>
                          <span>
                            <h6>{singleData?.desc}</h6>
                          </span>
                        </>
                      }
                      className="cardViewDetails"
                    >
                      <Row className="my-row" gutter={[16, 16]}>
                        <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
                          <div className="my-col-inner">
                            <h5>
                              <b>Key Features:</b>
                            </h5>
                            <h6>
                              <ul>
                                {singleData?.features.map((e: String) => {
                                  return <li>{e}</li>;
                                })}
                              </ul>
                            </h6>
                          </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
                          <div className="my-col-inner">
                            <h5>
                              <b>Technologies:</b>
                            </h5>
                            <h6>
                              {singleData?.technologies
                                ?.split(",")
                                ?.map((e: any, i: number) => {
                                  return (
                                    <Tag
                                      color="magenta"
                                      className={`technologies${i}`}
                                    >
                                      {e}
                                    </Tag>
                                  );
                                })}
                            </h6>
                          </div>
                        </Col>
                        <Col xs={24} sm={12} md={12} lg={12} xl={8} xxl={8}>
                          <div className="my-col-inner">
                            <h5>
                              <b>Impact:</b>
                            </h5>
                            <div className="impact-div">
                              <h6>{singleData?.impact}</h6>
                            </div>
                          </div>
                        </Col>
                        <Col span={24}>
                          <div className="case-study-bg">
                            <Row>
                              <Col
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                              >
                                <h5>
                                  <b>Case Study:</b>
                                </h5>
                              </Col>

                              <Col
                                xs={24}
                                sm={24}
                                md={24}
                                lg={24}
                                xl={24}
                                xxl={24}
                              >
                                <div>
                                  <Space>
                                    <img src={client} style={{ scale: ".8" }} />
                                    <span>
                                      <strong>Client:</strong> &nbsp;
                                      {singleData?.caseStudy["client"]}
                                    </span>
                                  </Space>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>

                        <Col span={24} className="study-details">
                          <Row gutter={[32, 32]}>
                            <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                              <div>
                                <img src={challenge} style={{ scale: "1" }} />
                              </div>
                              <h5>Challenge:</h5>
                              <span>{singleData?.caseStudy["challenge"]}</span>
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                              <div>
                                <img src={solution} style={{ scale: "1" }} />
                                <h5>Solution:</h5>
                                <span>{singleData?.caseStudy["solution"]}</span>
                              </div>
                            </Col>
                            <Col xs={24} sm={12} md={12} lg={8} xl={8} xxl={8}>
                              <div>
                                <img src={outcome} style={{ scale: "1" }} />
                                <h5>Outcome:</h5>
                                {/* <span>{singleData?.caseStudy["outcome"].replace(/(\d+(\.\d+)?%?)/g, `<span class="${"spanClassNumber"}">$1</span>`)}</span> */}
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: singleData?.caseStudy[
                                      "outcome"
                                    ].replace(
                                      /(\d+(\.\d+)?%?)/g,
                                      `<span class="${"spanClassNumber"}">$1</span>`
                                    ),
                                  }}
                                ></p>
                              </div>
                            </Col>
                          </Row>
                        </Col>
                        {/* <Col span={24}>
                          <h5>
                            <b>Case Study:</b>
                          </h5>
                          <h6>
                            <ul
                              style={{
                                listStyleType: "none",
                                paddingLeft: 0,
                                paddingTop: 0,
                              }}
                            >
                              {Object.keys(singleData?.caseStudy).map(
                                (e: any) => {
                                  return (
                                    <li>
                                      <b>{e}</b>:{" "}
                                      <i>{singleData?.caseStudy[e]}</i>
                                    </li>
                                  );
                                }
                              )}
                            </ul>
                          </h6>
                        </Col> */}
                      </Row>
                    </Card>
                    {/* <Divider style={{ borderColor: "#FFF" }} /> */}
                    {/* <Card
                      title={
                        <>
                          <h4>{singleData?.title}</h4>
                        </>
                      }
                      className="cardViewDetails"
                    >
                      <h5>Overview:</h5>
                      <h6>{singleData?.desc}</h6>
                      <Divider />
                      <h5>Key Features:</h5>
                      <h6>
                        <ul>
                          {singleData?.features.map((e: String) => {
                            return <li>{e}</li>;
                          })}
                        </ul>
                      </h6>
                      <Divider />
                      <h5>Technologies:</h5>
                      <h6>{singleData?.technologies}</h6>
                      <Divider />
                      <h5>Impact:</h5>
                      <h6>{singleData?.impact}</h6>
                      <Divider />
                      <h5>Case Study:</h5>
                      <h6>
                        <ul style={{ listStyleType: "none" }}>
                          {Object.keys(singleData?.caseStudy).map((e: any) => {
                            return (
                              <li>
                                <b>{e}</b>: {singleData?.caseStudy[e]}
                              </li>
                            );
                          })}
                        </ul>
                      </h6>
                      {singleData?.buttunData &&
                        singleData?.buttunData?.buttonText && (
                          <center>
                            <Button
                              onClick={() => {
                                singleData?.buttunData.buttonAction();
                              }}
                            >
                              <Space>
                                {singleData?.buttunData?.buttonText}
                                <BsArrowRight />
                              </Space>
                            </Button>
                          </center>
                        )}
                    </Card> */}
                  </>
                </MotionCol>
              </>
            );
          })}
        </Row>
      </div>
    </>
  );
  return <div>ServiceCardView</div>;
};

export default ServiceCardView;
